import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state:{
		token:"",
		userName:"",
	},
	mutations:{
		SET_USERNAME(state,userName){
			state.userName = userName
		}
	},
	getters:{
		getUserName:state=>state.userName
	}
})

export default store